$(document).ready(function(){
	$("table#cups").hide();
    $("h5#bots_tog").css("font-weight", "bold");
    $("h5#bots_tog").css("text-decoration", "underline");  
    $("h5#cups_tog").click(function(){
        $("table#cups").fadeIn("1000");
		$("table#bottles").hide();  
		$("h5#cups_tog").css("font-weight", "bold"); 
		$("h5#cups_tog").css("text-decoration", "underline");        
      	$("h5#bots_tog").css("font-weight", "normal");
      	$("h5#bots_tog").css("text-decoration", "none");
           
    });
    $("h5#bots_tog").click(function(){
        $("table#bottles").fadeIn("1000");   
      	$("table#cups").hide();      
    	$("h5#bots_tog").css("font-weight", "bold");  
		$("h5#bots_tog").css("text-decoration", "underline");        
        $("h5#cups_tog").css("font-weight", "normal");
      	$("h5#cups_tog").css("text-decoration", "none");        
    });    
});